const navigation = {
  sections: {
    contentOperations: "عمليات المحتوى",
    personalSetup: "الإعدادات الشخصية",
    systemAdministration: "إدارة النظام",
  },
  items: {
    dashboard: "لوحة التحكم",
    contentInbox: "صندوق المحتوى الخاص بي",
    promotions: "الحملات الترويجية",
    publishingHistory: "سجل النشر",
    sources: "مصادري",
    filters: "عوامل التصفية الخاصة بي",
    destinations: "وجهات النشر الخاصة بي",
    aiConfiguration: "إعدادات الذكاء الاصطناعي الخاصة بي",
    teamAccess: "الفريق والصلاحيات",
    systemSettings: "إعدادات النظام",
  },
  titles: {
    dashboard: "لوحة التحكم",
    feed: "صندوق المحتوى الخاص بي",
    history: "سجل النشر",
    promotion: "الحملات الترويجية",
    channels: "قنوات المصدر",
    filters: "عوامل تصفية المحتوى",
    destination: "وجهات النشر الخاصة بي",
    ai: "إعدادات الذكاء الاصطناعي",
    team: "الفريق والصلاحيات",
    database: "إعدادات النظام",
  },
  mobile: {
    home: "الرئيسية",
    inbox: "المحتوى",
    promotions: "الحملات",
    more: "المزيد",
    moreDescription: "السجل وإعدادات مساحة العمل",
  },
  account: {
    administrator: "المشرف",
    systemOwner: "مالك النظام",
    personalWorkspace: "مساحة العمل الشخصية",
    contentAdmin: "مشرف المحتوى",
    owner: "المالك",
    admin: "المشرف",
  },
  status: {
    workspace: "عمليات محتوى تيليجرام مدعومة بالذكاء الاصطناعي",
    publishingSetupRequired: "يلزم إعداد النشر",
    publishingTargetsReady_zero: "لا توجد وجهات نشر جاهزة",
    publishingTargetsReady_one: "وجهة نشر واحدة جاهزة",
    publishingTargetsReady_two: "وجهتا نشر جاهزتان",
    publishingTargetsReady_few: "{{count}} وجهات نشر جاهزة",
    publishingTargetsReady_many: "{{count}} وجهة نشر جاهزة",
    publishingTargetsReady_other: "{{count}} وجهة نشر جاهزة",
    secureWorkspace: "مساحة عمل آمنة",
    targetsReady_zero: "لا توجد وجهات جاهزة",
    targetsReady_one: "وجهة واحدة جاهزة",
    targetsReady_two: "وجهتان جاهزتان",
    targetsReady_few: "{{count}} وجهات جاهزة",
    targetsReady_many: "{{count}} وجهة جاهزة",
    targetsReady_other: "{{count}} وجهة جاهزة",
  },
  accessibility: {
    openDashboard: "فتح لوحة تحكم TGReposter",
    closeSidebar: "إغلاق الشريط الجانبي",
    openSidebar: "فتح الشريط الجانبي",
    primaryNavigation: "التنقل الرئيسي",
    signOut: "تسجيل الخروج",
    closeMoreNavigation: "إغلاق قائمة التنقل الإضافية",
    mobileNavigation: "التنقل عبر الهاتف",
    openPromotionCenter: "فتح مركز الحملات الترويجية",
  },
} as const;

export default navigation;
